(function() {
    // Execute immediately to catch scripts injected by content_for_header
    deferIntelligemsScripts();
    
    function deferIntelligemsScripts() {
        // Find all script tags with intelligems URL
        var scripts = document.querySelectorAll('script[src*="intelligems.io"], script[src*="/esm/"]');
        scripts.forEach(function(script) {
            if (script.src && (script.src.indexOf('intelligems.io') > -1 || script.src.indexOf('/esm/') > -1)) {
                // If script hasn't loaded yet, make it async
                if (!script.async && !script.defer && !script.hasAttribute('data-async-processed')) {
                    script.setAttribute('data-async-processed', 'true');
                    script.async = true;
                }
            }
        });
    }
    
    // Also use MutationObserver to catch scripts added dynamically
    if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function(mutations) {
            deferIntelligemsScripts();
        });
        
        observer.observe(document.head, {
            childList: true,
            subtree: true
        });
        
        // Stop observing after 3 seconds to avoid performance impact
        setTimeout(function() {
            observer.disconnect();
        }, 3000);
    }
})();
